import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import { toast } from "sonner";

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await register(form.email, form.password, form.name);
      toast.success(`Account created, ${user.name}`);
      navigate("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page" className="pt-32 pb-24 bg-[#F7F7F6] min-h-screen">
      <div className="max-w-md mx-auto px-6">
        <p className="font-mono-label text-[11px] text-neutral-500 mb-8">[ NEW ACCOUNT ]</p>
        <h1 className="font-serif-display font-light text-5xl mb-12">{t("auth_register_title")}</h1>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="register-name" required placeholder={t("auth_name")} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-neutral-300 bg-white px-4 py-4 font-body" />
          <input data-testid="register-email" required type="email" placeholder={t("auth_email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border border-neutral-300 bg-white px-4 py-4 font-body" />
          <input data-testid="register-password" required minLength={6} type="password" placeholder={t("auth_password")} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full border border-neutral-300 bg-white px-4 py-4 font-body" />
          <button data-testid="register-submit" type="submit" disabled={loading} className="btn-solid w-full justify-center">
            {loading ? "…" : `${t("auth_submit_register")} →`}
          </button>
        </form>
        <p className="mt-8 font-mono-label text-[10px] text-neutral-500">
          {t("auth_have_account")} <Link to="/login" className="text-black underline">{t("auth_login_link")}</Link>
        </p>
      </div>
    </div>
  );
}
